<template>
    <div>
        <Header/>
        <Nav :list="headerList"/>
        <div ref="content">
            <SingleBanner/>
            <MainContent/>
        </div>
        <Footer/>
    </div>
</template>
<script>
import MainContent from './components/mainContent';
import { mapState } from 'vuex'
export default {
    computed: mapState([
    ]),
    components:{
       MainContent
    },
    data() {
        return {
            headerList:[
                {name:'首页', href:'/'},
                {name:'IFM会员活动', href:'/'},
            ]
        }
    },
    mounted(){
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
.news{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    .single{
        width: 580px;
    }
}
</style>
